<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Documentos</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">                      
                        <Dropdown v-model="linkDocumento" :options="documentos" optionLabel="nome" optionValue="link" @hide="carregarPagina"
                            :filter="true" placeholder="Selecione um documento"/>
                        <hr>
                    </div>				             
                </div> 
                <router-view></router-view>
			</div>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            paginaAtual: '',
            linkDocumento: '',
            documentos: [],
        }
    },
    methods: {
        ...mapGetters('sessao', ['getPermissoes']),
        /**
         * 
         */
        carregarPagina() {             
            if(this.paginaAtual != this.linkDocumento) {
                this.paginaAtual = this.linkDocumento;
                this.$router.push(this.linkDocumento);              
            }
        },
        /**
         * 
         */
        carregarDocumentos() {
            let permissoes = this.getPermissoes();
            let definidos = [];
            definidos.push({nome:'Arquivo AFD', link:'/documentos/arquivo-afd', permissao:134});
            definidos.push({nome:'Arquivo AFDT/ACJEF/AEJ', link:'/documentos/arquivo-fiscal', permissao:135});
            definidos.push({nome:'Arquivo Folha', link:'/documentos/arquivo-folha', permissao:158});  
            definidos.push({nome:'Comprovante de Marcação', link:'/documentos/comprovante-marcacao', permissao:172});                    
            definidos.forEach(documento => {     
                if(permissoes.includes(documento.permissao)) {
                    this.documentos.push(documento);
                }     
            });
            this.documentos.push({nome:'Histórico de Relatórios/Documentos', link:'/documentos/historico', permissao:0}); 
        },
        /**
         * 
         */
        validarUrl() {         
            let tempHist = sessionStorage.getItem('tem_historico_documento');
            if(tempHist && this.$route.query.hist && (this.$route.query.hist == tempHist)) { 
                sessionStorage.removeItem('tem_historico_documento');
                this.linkDocumento = '/documentos/historico?id=' + this.$route.query.id;
                this.carregarPagina();
                setTimeout(() => {  
                    this.linkDocumento = '/documentos/historico';             
                    this.paginaAtual = this.linkDocumento; 
                }, 200);               
                return;
            }
            let tempLinkRapidoAfd = sessionStorage.getItem('tem_lik_rapido_afd');            
            if(tempLinkRapidoAfd && this.$route.query.lk_rp && (this.$route.query.lk_rp == tempLinkRapidoAfd)) { 
                sessionStorage.removeItem('tem_lik_rapido_afd');
                this.linkDocumento = '/documentos/arquivo-afd';
                this.carregarPagina();
                setTimeout(() => {  
                    this.linkDocumento = '/documentos/arquivo-afd';             
                    this.paginaAtual = this.linkDocumento; 
                }, 200);               
                return;
            }
        }
    },
    mounted() {
        this.carregarDocumentos();    
        this.validarUrl();    
    },
    watch: {
        $route () {
            this.validarUrl();
        }
    }
}
</script>

<style>
    
</style>